function fn_part_ui_carousel() {
    var $fn = $(".part_ui_carousel"),
        $carousel_images = $fn.find("[data-carousel-images]");

    if ($fn.length) {
        if ($carousel_images.children().length > 1) {
            $carousel_images.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                autoplay: false,
                autoplaySpeed: 3000,
                fade: true,
                cssEase: 'linear'
            }).on('afterChange', function(){
                $(this).find(".slick-active").find("img").addClass("lazyload");
            });
        }
    }
}